"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function TheJavaExperience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const trustIndicators = [{
    id: 1,
    text: "FAA Part 107 Certified"
  }, {
    id: 2,
    text: "Arizona Golf Specialists"
  }, {
    id: 3,
    text: "Affordable Scalable Pricing"
  }, {
    id: 4,
    text: "Premium Quality Cinematic Media"
  }];
  return <section data-section-id="234547" id="the-aerial-advantage" className="relative flex h-screen w-full items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/arizona_golf_course_hero.png">
          <source src="/video/golf_course_flyover.mp4" type="video/mp4" />
        </video>
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-black/60" />

      {}
      <div ref={ref} className={`relative z-20 flex flex-col items-center px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <h1 className="max-w-5xl font-serif text-5xl font-bold uppercase tracking-[0.1em] text-primary drop-shadow-2xl md:text-7xl lg:text-8xl">
          Every Course Deserves to Be Seen
        </h1>

        <h2 className="mt-4 font-serif text-2xl font-medium text-white/90 drop-shadow-md md:text-3xl lg:text-4xl">
          Helping Golf Courses Elevate How They’re Seen
        </h2>
        
        <p className="mt-8 max-w-3xl font-default text-lg font-medium text-white/90 drop-shadow-md md:text-xl tracking-wide leading-relaxed">
          We provide professional cinematic drone media with affordable, scalable pricing tailored for every course size. From municipal and public tracks to exclusive semi-private and private clubs, our high-end visuals are designed to be accessible for all.
        </p>

        {}
        <div className="mt-12 flex flex-col items-center gap-6 sm:flex-row">
          <div className="relative inline-flex group">
            <div className="absolute -inset-1 rounded-lg bg-primary opacity-30 blur-sm transition-all duration-500 group-hover:opacity-60 group-hover:blur-md" />
            <Button asChild size="lg" className="relative h-14 rounded-lg bg-primary px-10 text-lg font-semibold text-primary-foreground shadow-xl transition-all hover:scale-105 hover:bg-primary/90">
              <Link to="/RequestAQuotePage">
                Request a Quote
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>

          <Button asChild variant="outline" size="lg" className="h-14 rounded-lg border-2 border-white/30 bg-white/5 px-10 text-lg font-semibold text-white backdrop-blur-sm transition-all hover:border-primary hover:bg-primary/10 hover:text-primary">
            <Link to="/PackagesPage">
              View Packages
            </Link>
          </Button>
        </div>

        {}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-sm font-medium tracking-widest text-white/80 uppercase">
          {trustIndicators.map((item, i) => <React.Fragment key={item.id}>
              <span data-index={i} className={`transition-all duration-500 ${i === 2 || i === 3 ? "bg-primary/20 border border-primary/30 px-4 py-1.5 rounded-lg text-primary" : ""}`}>
                {item.text}
              </span>
              {i < trustIndicators.length - 1 && <span className="hidden sm:inline text-white/30">•</span>}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}